import { render, staticRenderFns } from "./SalesAuditSync.vue?vue&type=template&id=645855b7"
import script from "./SalesAuditSync.vue?vue&type=script&lang=js"
export * from "./SalesAuditSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports